// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3me4F","rootSmall":"AddTileButton_rootSmall__2l1bI"};